import React from 'react';
// import PropTypes from 'prop-types';
import UserGrid from 'Components/AdvisorApp/Viewport/Users/UserGrid';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import './index.css';

const UsersAndTeams = () => {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Users and Teams',
    isPageView: true,
  });
  return (
    <div
      className="user-and-team-grid padding-2"
      {...rootNodeProps}
    >
      <UserGrid />
    </div>
  );
};

export default UsersAndTeams;
